import { useEffect } from "react";
import { usePage } from "@inertiajs/react";
import { patchSideEffect } from "@/lib/fetchSideEffect";
import type { SharedProps } from "@/types";

function deviceTimeZone(): string | undefined {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
}

// The server's "today" and visible-from checks follow the user's zone; MCP and the
// widget bring no device clock, so the web client reports it.
export function useReportTimeZone() {
  const currentUser = usePage<SharedProps>().props.currentUser;
  const signedIn = currentUser !== undefined;
  const stored = currentUser?.timeZone;

  useEffect(() => {
    if (!signedIn) return;
    const zone = deviceTimeZone();
    if (zone && zone !== stored) patchSideEffect("/settings/time_zone", { time_zone: zone }).catch(() => {});
  }, [signedIn, stored]);
}
